import { render, staticRenderFns } from "./CoachGameReportsSummary.vue?vue&type=template&id=408c9968&"
import script from "./CoachGameReportsSummary.vue?vue&type=script&lang=ts&"
export * from "./CoachGameReportsSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports